import { Component, inject, OnInit } from '@angular/core';
import { StickyService } from '../../sticky.service';
import { v4 as uuidV4 } from 'uuid';
import { Router } from '@angular/router';
import { StepperService } from '../../stepper/stepper.service';
import { INITIAL_STEP, SUPPORTING_DOCUMENT_STEP } from '../../stepper/stepper.model';
import { DecisionEnum } from '../data-transmission/data-transmission.model';
import { NoValue } from '@tribeauto/ngx-mobilite-material';
import {
  EXTERNAL_ID_STORAGE,
  LOGIN_ID_STORAGE,
  OPEN_BANKING_AVAILABLE_STORAGE,
  POS_ID_STORAGE,
  TOKEN_STORAGE
} from '../../init/init.component';

@Component({
  selector: 'fol-mobi-sub-landing-page',
  imports: [],
  templateUrl: './mobi-sub-landing-page.html',
  styleUrl: 'mobi-sub-landing-page.scss'
})
export class MobiSubLandingPage implements OnInit {
  private readonly stickyService = inject(StickyService);
  private readonly stepperService = inject(StepperService);
  private readonly router = inject(Router);

  ngOnInit(): void {
    this.stickyService.clearStickyContent();
    const detailComponent = document.createElement('mobi-sub-landing');
    detailComponent.setAttribute('language', 'b2c.fr');
    detailComponent.setAttribute('external-id', localStorage.getItem(EXTERNAL_ID_STORAGE) ?? '');
    detailComponent.setAttribute('token', localStorage.getItem(TOKEN_STORAGE) ?? '');
    detailComponent.setAttribute('web-store-id', localStorage.getItem(POS_ID_STORAGE) ?? '');
    detailComponent.setAttribute('login-id', localStorage.getItem(LOGIN_ID_STORAGE) ?? '');
    detailComponent.setAttribute('session-uuid', uuidV4());
    detailComponent.setAttribute('legal-notice', 'ALL');
    detailComponent.setAttribute(
      'is-open-banking-available',
      localStorage.getItem(OPEN_BANKING_AVAILABLE_STORAGE) ?? 'false'
    );

    const page = document.getElementById('mobi-sub-landing-page');
    page?.append(detailComponent);

    detailComponent.addEventListener('backEvent', async event => {
      const backEvent: boolean = (event as CustomEvent).detail;
      if (backEvent) {
        this.stepperService.setActiveStep(INITIAL_STEP);
        await this.router.navigate(['/step']);
      }
    });

    detailComponent.addEventListener('lightColorContract', event => {
      const decision: DecisionEnum | NoValue = (event as CustomEvent).detail?.decision;
      const contractId: string | NoValue = (event as CustomEvent).detail.contractId;
      this.stepperService.setActiveStep(SUPPORTING_DOCUMENT_STEP);
      this.router.navigate(['/step'], { queryParams: { decision: contractId ? decision : null } });
    });
  }
}
